import { type FC, useContext, useEffect, useState } from "react";
import { formStateContext } from "@legacy_root/client_frontend/components/pages/scouts/scouts_select_locations";
import { axios } from "@root/libs/axios";
import {
  type CityProps,
  type LineProps,
} from "@legacy_root/client_frontend/components/pages/scouts/scouts_select_locations/src/city_and_station_modal/src/city_and_station_modal_props";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import { SelectedLists } from "./selected_lists";
import * as styles from "./styles.css";

type Props = {
  prefectureId: number;
  lineFetchUrl: string;
  stationFetchUrl: string;
  cityFetchUrl: string;
};

export const PrefectureOuter: FC<Props> = ({
  cityFetchUrl,
  lineFetchUrl,
  stationFetchUrl,
  prefectureId,
}) => {
  const { formState, dispatchFormState } = useContext(formStateContext);
  const [cityArray, setCityArray] = useState<CityProps[]>([]);
  const [lineArray, setLineArray] = useState<LineProps[]>([]);

  const fetchCityList = async () => {
    try {
      const { data } = await axios.get<CityProps[]>(cityFetchUrl, {
        params: { prefecture_id: prefectureId },
      });
      setCityArray(data);
    } catch (error) {
      sendErrorLog(
        new Error(error instanceof Error ? error.message : "市区町村の取得に失敗しました"),
      );
    }
  };

  const fetchLineList = async () => {
    try {
      const { data } = await axios.get<LineProps[]>(lineFetchUrl, {
        params: { prefecture_id: prefectureId },
      });
      setLineArray(data);
    } catch (error) {
      sendErrorLog(new Error(error instanceof Error ? error.message : "路線の取得に失敗しました"));
    }
  };

  const deletePrefecture = () => {
    dispatchFormState({
      type: "unSelectPref",
      value: prefectureId,
    });
  };

  useEffect(() => {
    fetchCityList();
    fetchLineList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.selectedPrefecture}>
      <div className={styles.prefectureNameOuter}>
        <div className={styles.prefectureNameInner}>
          <div className={styles.prefectureName}>
            <button
              className={styles.cancelButton}
              type="button"
              onClick={() => deletePrefecture()}
            >
              <i className="icon-cancel" />
            </button>
            {formState[prefectureId].name && <p>{formState[prefectureId].name}</p>}
          </div>
          <SelectedLists
            prefectureId={prefectureId}
            stationFetchUrl={stationFetchUrl}
            cityArray={cityArray}
            lineArray={lineArray}
            thisFormState={formState[prefectureId]}
          />
        </div>
      </div>
    </div>
  );
};
